import { IFunctionComponent } from '@omaze/app';
import React, { ReactElement } from 'react';

import { nonProfitFeatureNamespace } from '../../../../NonProfitFeature.namespace';

import { displayName, HEADLINE_QA } from './Headline.qa';

export const Headline: IFunctionComponent = nonProfitFeatureNamespace.createComponent(
    displayName,
    (): ReactElement => {
        return (
            <div className="flex flex-col items-center" data-testid={HEADLINE_QA.CONTAINER}>
                <span className="text-xl font-gellix text-center mt-0 text-gray-900 font-bold lg:text-3xl">
                    It&apos;s a win-win.
                </span>
            </div>
        );
    }
);
